<template>
    <i class="fas" :class="[icon]"/>
</template>

<script>
import {OrderState} from '@composables/orderStates';

export default {
    props: {
        status: String,
    },

    computed: {
        icon() {
            switch (this.status) {
                case OrderState.Confirmed:
                case OrderState.ReadyForPickup:
                case OrderState.Send:
                case OrderState.PickedUp:
                case OrderState.Delivered:
                    return 'fa-check';

                case OrderState.Pending:
                    return 'fa-clock';

                case OrderState.Rejected:
                case OrderState.Cancelled:
                    return 'fa-times';

                case OrderState.Refunded:
                    return 'fa-reply';

                default:
                    return 'fa-question';
            }
        },
    },
};
</script>
